import * as actionTypes from '../actions/actionTypes';

const initialState = {
    serviceCategories: null,
    selectedServiceID: null,
    productList: null,
    productListError: null,
    availableTimeList: null,
    selectedRoomId: null,
    selectedProduct: null,
    selectedTimestamp: null
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_SHOP:
            return {
                ...state,
                serviceCategories: null
            };
        case actionTypes.GET_SERVICES:
            return {
                ...state,
                serviceCategories: null,
                selectedServiceID: null
            };
        case actionTypes.GET_SERVICES_SUCCEEDED:
            return {
                ...state,
                serviceCategories: action.serviceCategories
            };
        case actionTypes.GET_PRODUCT_LIST:
            return {
                ...state,
                selectedRoomId: null,
                selectedProduct: null,
                productListError: null
            };
        case actionTypes.GET_PRODUCT_LIST_SUCCEEDED:
            return {
                ...state,
                productList: action.productList
            };
        case actionTypes.GET_PRODUCT_LIST_FAILED:
            const {message} = action;
            return {
                ...state,
                productListError: message
            };
        case actionTypes.GET_AVAILABLE_TIME_SUCCEEDED:
            return {
                ...state,
                availableTimeList: action.availableTimeList,
                selectedRoomId: action.roomId
            };
        case actionTypes.SELECT_SERVICE:
            const {serviceID} = action;
            return {
                ...state,
                selectedServiceID: serviceID
            };
        case actionTypes.SELECT_PRODUCT:
            const {product} = action;
            return {
                ...state,
                selectedProduct: product
            };
        case actionTypes.SELECT_TIMESTAMP:
            const {timestamp} = action;
            return {
                ...state,
                selectedTimestamp: timestamp
            };
        case actionTypes.GET_SHOP_SUCCEEDED:
            return {
                ...state,
                selectedServiceID: null
            };
        default:
            return state;
    }
};

export default reducer;